// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsent_root__11Rck"};